import Field from "@/components/Field";
import { Input } from "@/components/ui/input";
import { NO_DATA } from "@/constants";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface DurationPrFieldProps {
  prPlannedDuration?: string | null;
}

const DurationPrFieldComponent = ({
  prPlannedDuration,
}: DurationPrFieldProps) => {
  const { t } = useTranslation();
  return (
    <Field
      name="pr_planned_duration"
      wrapperClassName="flex-1"
      label={t("projectSchedules.fields.pr_planned_duration")}
      className="space-y-2"
      render={() => (
        <Input
          value={prPlannedDuration || NO_DATA}
          type="text"
          disabled
          readOnly
          className="w-full border border-gray-300 rounded-md bg-muted"
        />
      )}
    />
  );
};

export const DurationPrField = memo(DurationPrFieldComponent);
